import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";

const departmentOptions = [
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "CUTTING", value: "CUTTING" },
  { label: "Admin", value: "Admin" },
  { label: "STORE", value: "STORE" },
  { label: "IED", value: "IED" },
];

const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Foreman", value: "Foreman" },
];

const AttendanceReportLateOut = () => {
  const formik = useFormik({
    initialValues: {
      department: "",
      category: "",
      fromDate: "",
      toDate: "",
      code: "",
      name: "",
    },
    validationSchema: Yup.object({
      fromDate: Yup.string().required("From date is required"),
      toDate: Yup.string().required("To date is required"),
    }),
    onSubmit: (values) => {
      console.log("Search values:", values);
    },
  });

  const data = [
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "01.04.25", actual: "14:00", out: "14:10", late: "00:10" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "02.04.25", actual: "14:00", out: "14:06", late: "00:06" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "02.05.25", actual: "14:00", out: "14:04", late: "00:04" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "03.05.25", actual: "14:00", out: "14:07", late: "00:07" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "04.02.25", actual: "14:00", out: "14:26", late: "00:26" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "05.02.25", actual: "14:00", out: "14:26", late: "00:26" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "10.04.25", actual: "14:00", out: "14:08", late: "00:08" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "10.05.25", actual: "14:00", out: "14:03", late: "00:03" },
    { code: "001", department: "QUALITY CONTROL", name: "ARUN", date: "11.04.25", actual: "14:00", out: "14:09", late: "00:09" },
  ];

  const columns = [
    { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
    { Header: "Code", accessor: "code" },
    { Header: "Department", accessor: "department" },
    { Header: "Name", accessor: "name" },
    { Header: "Date", accessor: "date" },
    { Header: "Actual", accessor: "actual" },
    { Header: "Out", accessor: "out" },
    { Header: "Late", accessor: "late" },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Late Out List" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={4}>
                  <Label>
                    From Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={() => formik.setFieldTouched("fromDate", true)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate ? (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  ) : null}
                </Col>

                <Col md={4}>
                  <Label>
                    To Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={() => formik.setFieldTouched("toDate", true)}
                  />
                  {formik.touched.toDate && formik.errors.toDate ? (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  ) : null}
                </Col>


                <Col md={4}>
                  <Label>Code</Label>
                  <Input
                    name="code"
                    value={formik.values.code}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>Name</Label>
                  <Input
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={12} className="text-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-print mt-2">
                    <i className="fas fa-print me-1" /> Print
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportLateOut;
